//import React from 'react';
//import '../styles/new-styles.css';

//export default function HomeMidContent() {
//    return (
//        <section className="home-mid-content">
//            <div className="custom-pattern-layer"></div>

//            <div className="line-grid-wrap">
//                <span className="line-grid-1"></span>
//                <span className="line-grid-2"></span>
//                <span className="line-grid-3"></span>
//                <span className="line-grid-4"></span>
//                <span className="line-grid-5"></span>

//            </div>
//            <div className="auto-container">
//                <div className="row clearfix">
//                    <div className="col-lg-4 col-md-12 col-sm-12 image-column wow fadeInUp" data-wow-delay="100ms">
//                        <figure className="image-box mr_70">
//                            <img src="assets/images/resource/about-1.jpeg" alt="img" className="image-hover" />
//                        </figure>
//                    </div>
//                    <div className="col-lg-8 col-md-12 col-sm-12 content-column wow fadeInUp" data-wow-delay="150ms" style={{ textAlign: 'left' }}>
//                        <div className="content_block_one">
//                            <div className="content-box">
//                                <div className="sec-title light">
//                                    <h2 className="wow fadeInUp" data-wow-delay="200ms">
//                                        Ravline Corp: Your Trusted Partner in <span>Credit Restoration, Financial, Business, and Insurance Consulting</span>
//                                    </h2>
//                                </div>
//                                <div className="text-box">
//                                    <p className="wow fadeInUp" data-wow-delay="300ms">
//                                        Leveraging Over 30 Years of Industry Expertise to Deliver Comprehensive Solutions
//                                    </p>
//                                    <p className="wow fadeInUp" data-wow-delay="400ms">
//                                        With a solid track record of 10+ years in operation and a team of seasoned professionals with over three decades of experience, Ravline Corp is dedicated to providing a wide range of services designed to meet your unique needs and drive your success.
//                                    </p>
//                                </div>
//                            </div>
//                        </div>
//                    </div>
//                </div>
//            </div>
//        </section>
//    );
//}
import React from 'react';
import '../styles/new-styles.css';

export default function HomeMidContent() {
    return (
        <section className="home-mid-content">
            <div className="custom-pattern-layer"></div>

            
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="col-lg-4 col-md-12 col-sm-12 image-column wow fadeInUp" data-wow-delay="100ms">
                        <figure className="image-box mr_70">
                            <img src="assets/images/resource/about-1.jpeg" alt="img" className="image-hover" />
                        </figure>
                    </div>
                    <div className="col-lg-8 col-md-12 col-sm-12 content-column wow fadeInUp" data-wow-delay="150ms" style={{ textAlign: 'left' }}>
                        <div className="content_block_one">
                            <div className="content-box">
                                <div className="sec-title light">
                                    <h2 className="wow fadeInUp" data-wow-delay="200ms">
                                        Ravline Corp: Your Trusted Partner in <span>Credit Repair, Financial Services, Business Consulting, Insurance Solutions, Commercial and Residential Real Estate Services</span>
                                    </h2>
                                </div>
                                <div className="text-box">
                                    <p className="wow fadeInUp" data-wow-delay="300ms">
                                        Leveraging Over 30 Years of Industry Expertise to Deliver Comprehensive Solutions
                                    </p>
                                    <p className="wow fadeInUp" data-wow-delay="400ms">
                                        With a solid track record of 10+ years in operation and a team of seasoned professionals with over three decades of experience, Ravline Corp is dedicated to providing a wide range of services designed to meet your unique needs and drive your success.
                                    </p>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </section>
    );
}